import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLocale } from '../i18n/LocaleProvider';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Seo from '../components/Seo';

export default function NotFound() {
  const { t, locale } = useLocale();
  return (
    <div className="flex min-h-screen flex-col">
      <Seo title={`${t.notFoundTitle} · ${t.brandSuffix}`} description={t.notFoundBody} locale={locale} />
      <Header />
      <main className="container flex flex-1 flex-col items-center justify-center py-24 text-center">
        <p className="eyebrow">404</p>
        <h1 className="mt-3 font-display text-3xl text-greenDeep">{t.notFoundTitle}</h1>
        <p className="mt-2 max-w-sm text-muted-foreground">{t.notFoundBody}</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-greenDeep px-5 py-2 font-num text-xs uppercase tracking-wider text-cream transition-colors hover:bg-green"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          {t.backToList}
        </Link>
      </main>
      <Footer />
    </div>
  );
}
